import { Payload } from "../types";
import { translateTypeProperty } from "../utils/translates";

interface PlanilhaRow {
	[key: string]: any;
}

export const gerarPayloadFromPlanilha = (row: PlanilhaRow, rowImobiliaria: any, rowPeople?: any, rowAddress?: any): Payload => {
	const document = String(row["cpf"]);
	if (rowAddress) {
		rowAddress.addressZipcode = rowAddress.addressZipcode || row["CEP"] || "";
		rowAddress.addressStreet = rowAddress.addressStreet || row["Endereço"] || "";
		rowAddress.addressDistrict = rowAddress.addressDistrict || row["Bairro"] || "";
		rowAddress.addressCity = rowAddress.addressCity || row["Cidade"] || "";
		rowAddress.addressState = rowAddress.addressState || row["Estado"] || "";
		rowAddress.addressIBGE = rowAddress.addressIBGE || row["IBGE"] || "";
	}

	// console.log("row", row);
	// console.log("rowPeople", rowPeople);
	// console.log("rowAddress", rowAddress);
	// console.log("rowImobiliaria", rowImobiliaria);

	return {
		clientId: rowImobiliaria?.[0]?.id || "",
		name: rowPeople?.naturalPersonData.name || row["nome"],
		document: document,
		typePerson: document.length === 14 ? "legal" : "physical",
		sex: row["sexo"] || "male",
		birthDate: rowPeople?.naturalPersonData.birthDate || row["Data de Nascimento"],
		status: "pending",
		employmentRelationShip: "entrepreneur",
		motherName: rowPeople?.naturalPersonData.motherName || row["Nome da Mãe"] || "",
		maritalStatus: "single",
		email: row["email"] || "",
		phone: row["telefone"] || "",
		rentMonthsCount: '12',
		rentalCost: "only_rent",
		sendSerasa: "not_send_serasa",
		sendClick: "send",
		propertyFinally: translateTypeProperty(row["locacao"]) || "residential",
		isTipping: "0",
		propertyType: "Apartamento Padrao",
		addressZipcode: rowAddress?.addressZipcode || "",
		addressStreet: rowAddress?.addressStreet || "",
		addressNumber: row["numero"] || "",
		addressComplement: row["complemento"] || "",
		addressDistrict: rowAddress?.addressDistrict || "",
		addressCity: rowAddress?.addressCity || "",
		addressState: rowAddress?.addressState || "",
		addressIBGE: rowAddress?.addressIBGE || "",
		serasaResponse: "Development - sem valor legal. apenas para teste -",
		serasaAnalysisStatus: "approved",
		paymentMethod: "billet",
		contractBegin:  null,    ///row["iniciogarantia"] || null,
		contractEnd: null,    //row["fimgarantia"] || null,
		rentAmount: String(row["aluguel"] || "0.00"),
		condominiumAmount: String(row["condominio"]) || "0.00",
		electricEnergyAmount: "0.00",
		waterAmount: "0.00",
		gasAmount: "0.00",
		iptuAmount: "0.00",
		createdFrom: "web_app",
		assuranceMonthAmount: "0.00",
		lmi: "0",
		lmiAmount: "0.00",
		isContractRunner: '0',
		relation:'{}',     //JSON.stringify({
			// lessorName: row["Nome Locador"] || "",
			// landlordDocument: String(row["Documento Locador"] || "").replace(/\D/g, ""),
			// realEstate: rowImobiliaria?.name || row["Imobiliária"] || "",
		//}),
		planlist: "{}",
		id: "novo",
	};
};
